export default __webpack_public_path__ + "static/media/gallery_03.87d733f8.jpg";